import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { getProgramCss, getProgramHtml } from '../../api/requests';

function ProgramsIndex() {
  const [html, setHtml] = useState('');
  const { _id } = useParams();
  
  const init = useCallback(async() => {
    let res = await getProgramHtml(_id);
    if (res.ok) {
      const body = await res.json();
      const { htmlFile } = body;
      setHtml(htmlFile);
    }
    res = await getProgramCss(_id);
    if (res.ok) {
      const body = await res.text();
      const cssFile = body;
      const style = document.createElement('style');
      style.innerHTML = cssFile;
      document.getElementsByTagName('head')[0].appendChild(style);
    }
  }, [_id]);

  useEffect(() => {
    init();
  }, [init]);

  return <div dangerouslySetInnerHTML={{ __html: html }}/>;
}

export default ProgramsIndex;
